module.exports = __webpack_public_path__ + "img/Facebook_logo@2x.37e08fd3.png";